export function matchStateToTerm(state, value) {
  const id = state.lineOfBusiness === 'VOZ' ? state.serviceId : state.circuit
  return (
    state.productName.toLowerCase().indexOf(value.toLowerCase()) !== -1 ||
    id.toLowerCase().indexOf(value.toLowerCase()) !== -1
  )
}

export function sortStates(a, b, value) {
  const aLower = a.productName.toLowerCase()
  const bLower = b.productName.toLowerCase()
  const valueLower = value.toLowerCase()
  const queryPosA = aLower.indexOf(valueLower)
  const queryPosB = bLower.indexOf(valueLower)
  if (queryPosA !== queryPosB) {
    return queryPosA - queryPosB
  }
  return aLower < bLower ? -1 : 1
}



// WEBPACK FOOTER //
// ./src/components/RepairWizard/components/util.js